import { Button, Dialog, textVariants, Text, breakpoints } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { modalActionTypes, SEAT_MAP_UNBOOKED_SEGMENTS_DIALOG_ID } from '../constants/modal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const segmentsStyles = css`
  list-style: disc;
  margin: 12px 10px;
  padding-left: 14px;

  [dir='rtl'] & {
    padding-left: 0;
    padding-right: 14px;
  }
`;
const dividerStyles = css`
  margin: 0 2px;
`;
const buttonsWrapperStyles = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 5px;

  @media (min-width: ${breakpoints._970}) {
    flex-direction: row;
  }
`;
const buttonStyles = css`
  flex: 1;
`;
const SeatMapUnbookedSegmentsDialog = ({
  dismissText,
  isOpen,
  onSelection,
  segments
}) => {
  var _segments$0$boundSegm, _segments$;
  const {
    t
  } = useTranslation();
  const segmentIndex = (_segments$0$boundSegm = (_segments$ = segments[0]) === null || _segments$ === void 0 ? void 0 : _segments$.boundSegmentIndex) !== null && _segments$0$boundSegm !== void 0 ? _segments$0$boundSegm : null;
  return /*#__PURE__*/_jsxs(Dialog, {
    closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
    "data-testid": SEAT_MAP_UNBOOKED_SEGMENTS_DIALOG_ID,
    id: SEAT_MAP_UNBOOKED_SEGMENTS_DIALOG_ID,
    isOpen: isOpen,
    title: t('Product.SeatMap.AllSeatsSelectedConfirmation.Title'),
    children: [/*#__PURE__*/_jsx(Text, {
      variant: textVariants._14,
      children: t('Product.SeatMap.AllSeatsSelectedConfirmation.Text')
    }), /*#__PURE__*/_jsx("ul", {
      className: segmentsStyles,
      children: segments.map(({
        from,
        to
      }, i) => /*#__PURE__*/_jsxs("li", {
        children: [from.city, " ", /*#__PURE__*/_jsx(Text, {
          variant: textVariants._12_BOLD,
          children: from.iata
        }), /*#__PURE__*/_jsx(Text, {
          className: dividerStyles,
          children: "\u2013"
        }), to.city, " ", /*#__PURE__*/_jsx(Text, {
          variant: textVariants._12_BOLD,
          children: to.iata
        })]
      }, `${from.iata}-${to.iata}-${i}`))
    }), /*#__PURE__*/_jsxs("div", {
      className: buttonsWrapperStyles,
      children: [/*#__PURE__*/_jsx(Button, {
        className: buttonStyles,
        "data-testid": "seatMap-allSeatsSelectedConfirmation-dismiss",
        onClick: () => onSelection(modalActionTypes.SEAT_MAP_PERSIST_ACTION_DISMISS, null),
        children: dismissText
      }), /*#__PURE__*/_jsx(Button, {
        className: buttonStyles,
        "data-testid": "seatMap-allSeatsSelectedConfirmation-accept",
        onClick: () => onSelection(modalActionTypes.SEAT_MAP_PERSIST_ACTION_ACCEPT, segmentIndex),
        variant: "primary",
        children: t('Product.SeatMap.AllSeatsSelectedConfirmation.AcceptText')
      })]
    })]
  });
};
export default SeatMapUnbookedSegmentsDialog;
//# sourceMappingURL=SeatMapUnbookedSegmentsDialog.js.map